import React from "react";
import SwitchStyle from "./Switch.style";
import { FormControlLabel as MuiFormControlLabel } from "@mui/material";

function SwitchBasic({
	nameSx, // object
	name = "Switch", // string
	labelPlacement = "end", // 'bottom' | 'end' | 'start' | 'top'
	checked = false, // bool
	checkedIcon, // node
	classes, // object
	color = "primary", // 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning'
	defaultChecked = false, // bool
	disabled = false, // bool
	disableRipple = false, // bool
	edge = false, // 'end' | 'start' | false
	icon, // node
	id = "", // string
	inputProps, // object
	inputRef, // ref
	required = false, // bool
	size = "medium", // 'medium' | 'small'
	sx, // object
	value = false, // any
	onChange = (e) => {},
}) {
	const ChangeSwitch = (e) => {
		onChange(e.target.checked);
	};

	return (
		<MuiFormControlLabel
			sx={nameSx}
			label={name}
			labelPlacement={labelPlacement}
			disabled={disabled}
			required={required}
			control={
				<SwitchStyle
					checked={checked}
					// checkedIcon={checkedIcon}
					classes={classes}
					color={color}
					// defaultChecked={defaultChecked}
					disableRipple={disableRipple}
					edge={edge}
					// icon={icon}
					id={id}
					inputProps={inputProps}
					inputRef={inputRef}
					size={size}
					sx={sx}
					onChange={ChangeSwitch}
				/>
			}
		/>
	);
}

export default React.memo(SwitchBasic);
